/**
 * API dispatcher (2026-09-23): routes to the LIVE backend adapter when enabled,
 * otherwise falls back to the original IndexedDB mock workspace.
 * Flag: localStorage 'yvr_live_mode' = '1' (or window.__YVR_LIVE__ === true)
 */
import * as mock from './api-mock.mjs';
import * as live from './api-live.mjs';

export const isLive = () => window.__YVR_LIVE__ === true || localStorage.getItem('yvr_live_mode') === '1';
function impl() { return isLive() ? live : mock; }

// Re-export adapter-agnostic helpers that work in both modes
export { setToken } from './api-live.mjs';

// Dispatched contract:
export const getSession = (...a) => impl().getSession(...a);
export const loginUser = (...a) => impl().loginUser(...a);
export const registerUser = (...a) => impl().registerUser(...a);
export const logoutUser = (...a) => impl().logoutUser(...a);
export const getChallenges = (...a) => impl().getChallenges(...a);
export const getChallenge = (...a) => impl().getChallenge(...a);
export const getWaypoints = (...a) => impl().getWaypoints(...a);
export const createChallenge = (...a) => impl().createChallenge(...a);
export const updateChallenge = (...a) => impl().updateChallenge(...a);
export const archiveChallenge = (...a) => impl().archiveChallenge(...a);
export const deleteChallenge = (...a) => impl().deleteChallenge(...a);
export const duplicateChallenge = (...a) => impl().duplicateChallenge(...a);
export const joinChallenge = (...a) => impl().joinChallenge(...a);
export const recordActivity = (...a) => impl().recordActivity(...a);
export const approveActivity = (...a) => impl().approveActivity(...a);
export const rejectActivity = (...a) => impl().rejectActivity(...a);
export const excludeActivity = (...a) => impl().excludeActivity(...a);
export const editActivity = (...a) => impl().editActivity(...a);
export const deleteActivity = (...a) => impl().deleteActivity(...a);
export const getActivities = (...a) => impl().getActivities(...a);
export const getLeaderboard = (...a) => impl().getLeaderboard(...a);
export const getWeeklyGoal = (...a) => impl().getWeeklyGoal(...a);
export const getStats = (...a) => impl().getStats(...a);
export const getDirectory = (...a) => impl().getDirectory(...a);
export const getMedals = (...a) => impl().getMedals(...a);
export const getAuditJournal = (...a) => impl().getAuditJournal(...a);
export const getUnreadJourney = (...a) => impl().getUnreadJourney(...a);
export const markJourneySeen = (...a) => impl().markJourneySeen(...a);
export const issueMedal = (...a) => impl().issueMedal(...a);
export const updateShipment = (...a) => impl().updateShipment(...a);
export const updateProfile = (...a) => impl().updateProfile(...a);
export const getSettings = (...a) => impl().getSettings(...a);
export const getQueue = (...a) => impl().getQueue(...a);
export const retrySync = (...a) => impl().retrySync(...a);
export const syncNow = (...a) => impl().syncNow(...a);
export const startSync = (...a) => impl().startSync(...a);
export const saveRecording = (...a) => impl().saveRecording(...a);
export const getRecording = (...a) => impl().getRecording(...a);
export const discardRecording = (...a) => impl().discardRecording(...a);
export const uploadImage = (...a) => impl().uploadImage(...a);
export const requestWordPressSync = (...a) => impl().requestWordPressSync(...a);

// Mock-only extras re-exported for compatibility (demo tour, seed data)
export { DEMO_IDS, DEMO_PASSWORD, WP_MAPPING, blankChallenge } from './api-mock.mjs';
export const demoLogin = (...a) => impl().demoLogin ? impl().demoLogin(...a) : mock.demoLogin(...a);
export const createRestAdapter = (...a) => impl().createRestAdapter ? impl().createRestAdapter(...a) : mock.createRestAdapter(...a);
export const endpointMap = (...a) => impl().endpointMap ? impl().endpointMap(...a) : mock.endpointMap(...a);
export const updateSettings = (...a) => impl().updateSettings ? impl().updateSettings(...a) : mock.updateSettings(...a);
